import { imageStore } from '../images.js';
import Drawable from '../entities/Drawable.js';
import Sprite from './Sprite.js';
import PixelText from './PixelText.js';

export default class MartItemAmountBox extends Drawable {
    constructor({ position, stateMachine, costPerItem }) {
        super();
        this.stateMachine = stateMachine;
        this.amount = 1;
        this.costPerItem = costPerItem;
        this.cost = costPerItem;
        this.position = position;

        this.sprites = {};
        this.sprites.boxImage = new Sprite({
            position: this.position,
            image: imageStore.get('img/menu_box_64x32_empty.png'),
        });

        this.amountText = new PixelText({
            text: `x ${this.amount}`,
            color: 'black',
            position: {
                x: this.position.x + 8,
                y: this.position.y + 13,
            },
        });

        this.totalCostText = new PixelText({
            text: `\u20DB ${this.amount * this.costPerItem}`,
            position: {
                x: this.position.x + 80 - 8,
                y: this.position.y + 13,
            },
            color: 'black',
            textAlign: 'right',
        });
    }

    draw() {
        if (!this.visible) {
            return;
        }

        this.sprites.boxImage.draw();
        this.amountText.text = `\u00D7 ${this.amount}`;
        this.totalCostText.text = `\u20BD ${this.amount * this.costPerItem}`;
        this.amountText.draw();
        this.totalCostText.draw();
    }
}
